<div class="wf-root" *ngIf="wf" [class.review-inspecting]="!!reviewPreview" [class.review-open]="reviewPanelOpen">
  <!-- ===================== TOP BAR ===================== -->
  <header class="wf-header">
    <div id="wf-workflow-identity" class="wf-identity review-locatable"
         [class.review-target]="isReviewTarget('workflow')">
      <div class="wf-iconbox">
        <wf-icon name="workflow" [size]="18"></wf-icon>
      </div>
      <div class="wf-meta">
        <div class="wf-title-row">
          <span class="wf-name" contenteditable="true" (blur)="onNameBlur($event)">{{ wf.name }}</span>
          <span class="wf-badge" [ngClass]="statusClass">{{ statusLabel }}</span>
          <span class="wf-version">v{{ wf.version }}</span>
        </div>
        <div class="wf-sub">{{ wf.sku }} · {{ tierLabel }}</div>
      </div>
    </div>

    <div id="wf-stage-strip" class="wf-stages review-locatable" [class.review-target]="isReviewTarget('stages')">
      <div *ngFor="let i of stageIndices" class="stage-pill-wrap">
        <button class="stage-pill review-locatable" [class.active]="wf.activeStage === i" [class.removable]="canRemoveStage(i)"
                [attr.id]="'wf-stage-pill-' + i" [class.review-target]="isReviewTarget('stage', i) || isReviewTarget('final-output', i)"
                (click)="selectStage(i)" [attr.aria-pressed]="wf.activeStage === i">
          <span *ngIf="stageTimeBudget(i)" class="s-timer" aria-hidden="true">
            <wf-icon name="clock" [size]="12"></wf-icon>{{ stageTimeBudget(i) }}
          </span>
          <span *ngIf="!stageTimeBudget(i)" class="s-dot" aria-hidden="true"></span>
          {{ stageDisplayName(i) }}
          <span *ngIf="stageHasConditional(i)" class="badge-chip" title="Conditional routing"><wf-icon name="zap" [size]="11"></wf-icon></span>
          <span *ngIf="stageImmutable(i)" class="badge-chip" title="Immutable"><wf-icon name="lock" [size]="11"></wf-icon></span>
          <span *ngIf="i === wf.stageCount && wf.finalOutputs.pdf.enabled" class="badge-chip" title="PDF output"><wf-icon name="file-text" [size]="11"></wf-icon></span>
          <span *ngIf="i === wf.stageCount && wf.finalOutputs.email.enabled" class="badge-chip" title="Email output"><wf-icon name="mail" [size]="11"></wf-icon></span>
        </button>
        <button
          *ngIf="canRemoveStage(i)"
          type="button"
          class="stage-remove"
          [attr.aria-label]="'Remove Stage ' + i"
          [title]="'Remove Stage ' + i"
          (click)="confirmRemoveStage(i, $event)">
          <wf-icon name="x" [size]="10"></wf-icon>
        </button>
      </div>
      <button *ngIf="reviewRemovedStageNumber() as removedStage" type="button"
              class="stage-pill review-stage-ghost review-target review-target-removed"
              [attr.id]="'wf-stage-pill-' + removedStage" disabled>
        <span class="s-dot" aria-hidden="true"></span>
        {{ reviewSavedStageName() }}
        <span class="badge-chip">Removed · saved</span>
      </button>
      <button
        *ngIf="canAddStage()"
        type="button"
        class="stage-add"
        [attr.aria-label]="'Add Stage ' + (wf.stageCount + 1)"
        [title]="'Add Stage ' + (wf.stageCount + 1)"
        (click)="addStage($event)">
        <wf-icon name="plus" [size]="12"></wf-icon>
        <span>Add Stage</span>
      </button>
    </div>

    <div class="wf-toolbar">
      <div class="wf-menu-wrap">
        <button class="tb-btn" (click)="toggleLoadMenu($event)">
          <wf-icon name="bar-chart-2" [size]="15"></wf-icon>
          <span class="label">Load Example</span>
          <wf-icon name="chevron-down" [size]="12" class="chevron caret" [class.caret-open]="loadMenuOpen"></wf-icon>
        </button>
        <div class="menu-dropdown wide" *ngIf="loadMenuOpen" (click)="$event.stopPropagation()">
          <button (click)="pickExample('leave')">
            <div>
              <div class="menu-title">SF-HR-004 Leave Workflow</div>
              <div class="menu-sub">3 stages · conditional routing · guard</div>
            </div>
          </button>
          <div class="menu-divider"></div>
          <button (click)="pickExample('security')">
            <div>
              <div class="menu-title">SF-SEC-001 Security Evidence Log</div>
              <div class="menu-sub">3 stages · immutable · per-item notify</div>
            </div>
          </button>
        </div>
      </div>

      <button id="wf-routing-trigger" class="tb-btn review-locatable" [class.review-target]="isReviewTarget('routing', wf.activeStage)"
              (click)="openRouting()">
        <wf-icon name="users" [size]="15"></wf-icon>
        <span class="label">Who receives this stage?</span>
      </button>

      <div class="tb-divider" role="separator"></div>

      <button class="tb-btn" *ngIf="!isActive && !isInactive" (click)="validateAndOpen()">
        <wf-icon name="shield-check" [size]="15"></wf-icon>
        <span class="label">Validate</span>
      </button>

      <div class="wf-menu-wrap" *ngIf="!isActive && !isInactive">
        <button class="tb-btn tb-btn-primary" [disabled]="saving || isOffline" (click)="toggleSaveMenu($event)" [title]="isOffline ? 'Reconnect to save this draft' : 'Save options'">
          <wf-icon name="save" [size]="15"></wf-icon>
          <span class="label">Save Options</span>
          <wf-icon name="chevron-down" [size]="12" class="chevron caret" [class.caret-open]="saveMenuOpen"></wf-icon>
        </button>
        <div class="menu-dropdown" *ngIf="saveMenuOpen" (click)="$event.stopPropagation()">
          <button (click)="saveDraftFromMenu()" [disabled]="saving">
            <wf-icon name="save" [size]="16"></wf-icon> Save as Draft
          </button>
          <div class="menu-divider"></div>
          <button (click)="savePublishFromMenu()" [disabled]="saving" [title]="publishTitle">
            <wf-icon name="rocket" [size]="16"></wf-icon> Publish
          </button>
        </div>
      </div>

      <button class="tb-btn tb-btn-primary" *ngIf="isActive" (click)="editActive()">
        <wf-icon name="pencil" [size]="15"></wf-icon>
        <span class="label">Edit (new version)</span>
      </button>

      <div class="wf-menu-wrap">
        <button id="wf-more-options" class="tb-icon-btn" (click)="toggleOverflowMenu($event)" aria-label="More options">
          <wf-icon name="dots-horizontal" [size]="16"></wf-icon>
        </button>
        <div class="menu-dropdown" *ngIf="overflowMenuOpen" (click)="$event.stopPropagation()">
          <button *ngIf="hasUnsavedChanges()" (click)="openReview()">
            <wf-icon name="file-text" [size]="16"></wf-icon> Review unsaved changes
          </button>
          <button *ngIf="hasUnsavedChanges()" [disabled]="saving" (click)="discardUnsavedChanges()">
            <wf-icon name="x-circle" [size]="16"></wf-icon> Discard unsaved changes
          </button>
          <div class="menu-divider" *ngIf="hasUnsavedChanges()"></div>
          <button *ngIf="canViewAuditLog" (click)="openHistory()"><wf-icon name="history" [size]="16"></wf-icon> View History (Audit Log)</button>
          <div class="menu-divider" *ngIf="canViewAuditLog"></div>
          <button class="danger" [disabled]="!isActive || saving" (click)="confirmDeactivate()">
            <wf-icon name="power" [size]="16"></wf-icon> Deactivate workflow
          </button>
        </div>
      </div>

      <button class="tb-btn" (click)="openSchedule()" title="Schedule this workflow">
        <wf-icon name="clock" [size]="15"></wf-icon>
        <span class="label">Schedule</span>
      </button>

      <button class="tb-btn tb-btn-assign" (click)="openAssign()" title="Assign this workflow">
        <wf-icon [name]="workflowAssigned ? 'check-check' : 'users'" [size]="15"></wf-icon>
        <span class="label">Assign</span>
      </button>
    </div>
  </header>

  <section class="workflow-status-banner offline" *ngIf="isOffline">
    <strong>Working offline</strong>
    <span>You can keep editing, but your changes have not been saved yet.</span>
  </section>
  <section class="workflow-status-banner recovered" *ngIf="!isOffline && recoveryStatus === 'recovered'">
    <strong>Unsaved changes recovered from this device.</strong>
    <button type="button" (click)="openReview()">Review changes</button>
    <button type="button" (click)="discardUnsavedChanges()">Discard</button>
  </section>
  <section class="workflow-status-banner conflict" *ngIf="recoveryStatus === 'conflict'">
    <span><strong>Recovered changes need review.</strong> The saved workflow changed since this recovery copy was created.</span>
    <button type="button" (click)="reviewRecoveryConflict()">Review recovered changes</button>
    <button type="button" (click)="discardRecoveryConflict()">Discard recovery and open latest version</button>
  </section>

  <!-- ===================== MAIN LAYOUT ===================== -->
  <div class="wf-main">
    <!-- Canvas -->
    <section class="wf-canvas">
      <div class="wf-canvas-inner">
        <div class="wf-stage-head review-locatable" [class.review-target]="isReviewTarget('stage', wf.activeStage)">
          <div>
            <h2 class="wf-stage-title">{{ stageDisplayName(wf.activeStage) }} Configuration</h2>
            <p class="wf-stage-sub">{{ stageSubtitle }}</p>
          </div>
          <div class="wf-stage-badges">
            <span *ngIf="stageHasConditional(wf.activeStage)" class="sbadge amber"><wf-icon name="zap" [size]="12"></wf-icon> Conditional</span>
            <span *ngIf="activeStage.routing.immutable" class="sbadge grey"><wf-icon name="lock" [size]="12"></wf-icon> Immutable</span>
            <span *ngIf="activeStage.routing.secondApprover" class="sbadge purple">2nd Approver</span>
            <span *ngIf="activeStage.routing.timeBudget.value > 0" class="sbadge blue">
              <wf-icon name="timer" [size]="12"></wf-icon> {{ activeStage.routing.timeBudget.value }} {{ activeStage.routing.timeBudget.unit }}
            </span>
          </div>
        </div>

        <div class="review-canvas-banner" *ngIf="reviewPreview && reviewPreview.target.stage === wf.activeStage"
             [ngClass]="'review-banner-' + reviewPreview.kind" role="status">
          <span class="review-canvas-kicker">Showing on canvas</span>
          <strong>{{ reviewPreview.label }}</strong>
          <span>{{ reviewCardStatus(reviewPreview) }}</span>
          <button *ngIf="reviewPreviewPinned && !reviewPanelOpen" type="button" class="review-reopen"
                  (click)="openReview()">Review all changes</button>
        </div>

        <!-- FORM FIELDS -->
        <div class="wf-section-label">Form Fields</div>
        <div id="wf-form-rows" class="wf-form-rows review-locatable"
             [class.review-target]="isReviewTarget('form', wf.activeStage) || isReviewHiddenFieldsFallback(wf.activeStage)">
          <ng-container *ngIf="reviewPreview?.kind === 'removed'">
            <ng-container *ngIf="reviewSavedField() as savedField">
              <div class="review-saved-layout">
                <ng-container *ngTemplateOutlet="savedFieldReviewCard; context: { field: savedField, removed: true }"></ng-container>
              </div>
            </ng-container>
          </ng-container>
          <!-- empty state -->
          <div *ngIf="activeStage.rows.length === 0" class="wf-empty"
               [class.drop-zone-active]="hover === 'empty'"
               (dragover)="allowDrop($event, 'empty')" (dragleave)="clearHover('empty')"
               (drop)="dropNewRow($event, 0)">
            <wf-icon name="mouse-pointer-2" [size]="22"></wf-icon>
            <div>Drag fields from the palette to begin building this stage.</div>
            <div class="wf-empty-hint">On a small screen, tap a field in the palette to add it.</div>
          </div>

          <ng-container *ngIf="activeStage.rows.length > 0">
            <ng-container *ngFor="let row of activeStage.rows; let rIdx = index; trackBy: trackByIndex">
              <div class="row-drop" [class.drop-zone-active]="hover === 'row-' + rIdx"
                   (dragover)="allowDrop($event, 'row-' + rIdx)" (dragleave)="clearHover('row-' + rIdx)"
                   (drop)="dropNewRow($event, rIdx)"></div>

              <div class="row-wrap" [class.drag-over]="hover === 'side-' + rIdx">
                <ng-container *ngFor="let entry of row; trackBy: trackByEntryKey">
                  <ng-container *ngIf="isReviewFieldTarget(entry) && reviewPreview?.kind === 'changed'">
                    <ng-container *ngIf="reviewSavedField() as savedField">
                      <ng-container *ngTemplateOutlet="savedFieldReviewCard; context: { field: savedField, removed: false }"></ng-container>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngTemplateOutlet="fieldCard; context: { entry: entry }"></ng-container>
                </ng-container>
                <div *ngIf="row.length < 3" class="row-side"
                     [class.drop-zone-active]="hover === 'side-' + rIdx"
                     (dragover)="allowDrop($event, 'side-' + rIdx)" (dragleave)="clearHover('side-' + rIdx)"
                     (drop)="dropIntoRow($event, rIdx)">+</div>
              </div>
            </ng-container>

            <div class="row-drop" [class.drop-zone-active]="hover === 'row-' + activeStage.rows.length"
                 (dragover)="allowDrop($event, 'row-' + activeStage.rows.length)"
                 (dragleave)="clearHover('row-' + activeStage.rows.length)"
                 (drop)="dropNewRow($event, activeStage.rows.length)"></div>
          </ng-container>
        </div>

        <!-- HIDDEN INHERITED TRAY -->
        <div id="wf-hidden-fields" class="hidden-tray review-locatable"
             [class.review-target]="isReviewTarget('hidden-fields', wf.activeStage)"
             [class.review-target-removed]="isReviewTarget('hidden-fields', wf.activeStage) && reviewPreview?.kind === 'removed'"
             *ngIf="wf.activeStage > 1 && hiddenPoolForStage(wf.activeStage).length > 0">
          <div class="hidden-tray-header">
            <div class="ht-left">
              <wf-icon name="eye-off" [size]="16"></wf-icon>
              <span class="ht-title">Hidden inherited fields</span>
              <span class="ht-count">({{ hiddenPoolForStage(wf.activeStage).length }})</span>
            </div>
          </div>
          <div class="hidden-tray-list">
            <div class="hidden-tray-item" *ngFor="let f of hiddenPoolForStage(wf.activeStage)">
              <span class="hti-left">
                <wf-icon [name]="fieldTypes[f.type].icon" [size]="14"></wf-icon>
                <span class="hti-label">{{ f.label }}</span>
                <span class="hti-type">{{ fieldTypes[f.type].label }}</span>
              </span>
              <button (click)="readdMirrorToStage(wf.activeStage, f.id)">+ Add back</button>
            </div>
          </div>
        </div>

        <div class="wf-foot-note">
          <wf-icon name="info" [size]="14"></wf-icon>
          Max 10 rows, 3 elements per row. Row widths auto-balance.
        </div>

        <!-- DIVIDER -->
        <div class="stage-divider"><span>Stage Actions</span></div>

        <!-- ACTION BUTTONS -->
        <div id="wf-actions-area" class="wf-actions-area review-locatable" [class.drop-zone-active]="hover === 'actions'"
             [class.review-target]="isReviewTarget('actions', wf.activeStage)"
             (dragover)="allowDrop($event, 'actions')" (dragleave)="clearHover('actions')"
             (drop)="dropActions($event)">
          <ng-container *ngIf="reviewSavedAction() as savedAction">
            <div class="review-saved-action" data-review-ghost="action"
                 [attr.id]="reviewPreview?.kind === 'removed' ? reviewActionDomId(wf.activeStage, reviewPreview?.target?.entityKey || '') : null"
                 [style.order]="(reviewPreview?.target?.beforePosition?.column || 0) * 2">
              <span class="review-saved-badge">{{ reviewPreview?.kind === 'removed' ? 'Removed' : 'Saved version' }}</span>
              <div class="action-btn-card review-saved-card" [ngClass]="actionColorClass(savedAction.type)">
                <wf-icon [name]="actionTypes[savedAction.type].icon" [size]="16"></wf-icon>
                <span>{{ savedAction.label }}</span>
                <wf-icon *ngIf="savedAction.requireComment" name="message-square-text" [size]="14"></wf-icon>
              </div>
            </div>
          </ng-container>
          <div *ngIf="activeStage.actions.length === 0" class="wf-actions-empty">Drag action buttons here.</div>
          <div *ngFor="let a of activeStage.actions; let aIdx = index; trackBy: trackByActionId" class="action-btn-card"
               [style.order]="aIdx * 2 + 1"
               [attr.id]="reviewActionDomId(wf.activeStage, 'action:' + a.id)" [attr.data-action-id]="a.id"
               [class.review-target]="isReviewActionTarget(a)" [class.review-target-added]="isReviewActionTarget(a) && reviewPreview?.kind === 'added'"
               [class.review-target-changed]="isReviewActionTarget(a) && reviewPreview?.kind === 'changed'"
               [ngClass]="actionColorClass(a.type)">
            <wf-icon [name]="actionTypes[a.type].icon" [size]="16"></wf-icon>
            <span contenteditable="true" (blur)="onActionLabelBlur(a, $event)">{{ a.label }}</span>
            <wf-icon *ngIf="a.requireComment" name="message-square-text" [size]="14"
                     [title]="a.commentPrompt || 'Comment required'"></wf-icon>
            <div class="ctrls">
              <button (click)="toggleRequireComment(a)" title="Configure comment">
                <wf-icon name="message-square" [size]="14"></wf-icon>
              </button>
              <button (click)="deleteAction(a)" title="Delete"><wf-icon name="x" [size]="14"></wf-icon></button>
            </div>
          </div>
        </div>

        <p class="inline-error" *ngIf="activeStage.actions.length === 0">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> At least one action must be allowed at each stage
        </p>
      </div>
    </section>

    <!-- Field Palette -->
    <aside class="wf-palette" [class.open]="paletteOpen">
      <div class="palette-head">
        <div>
          <div class="palette-title">Field Palette</div>
          <div class="palette-sub">Drag elements onto the canvas — or tap to add</div>
        </div>
        <button class="palette-close" (click)="paletteOpen = false"><wf-icon name="x" [size]="18"></wf-icon></button>
      </div>

      <div class="palette-banner" *ngIf="wf.activeStage > 1">
        Stage 1 fields appear here automatically as read-only mirrors. Use the palette only for fields that should
        be captured at Stage {{ wf.activeStage }}.
      </div>

      <div class="palette-list">
        <div class="palette-group-title">Input Fields</div>
        <div class="palette-item input" *ngFor="let p of paletteInput" draggable="true"
             (dragstart)="onPaletteDragStart($event, 'field', p.key)" (dragend)="onDragEnd()"
             (click)="addFromPalette('field', p.key)">
          <wf-icon name="grip-vertical" [size]="16" class="grip"></wf-icon>
          <wf-icon [name]="p.meta.icon" [size]="16" class="pi-icon"></wf-icon>
          <span>{{ p.meta.label }}</span>
        </div>

        <div class="palette-group-title">Auto-Generated Fields</div>
        <div class="palette-item auto" *ngFor="let p of paletteAuto" draggable="true"
             (dragstart)="onPaletteDragStart($event, 'field', p.key)" (dragend)="onDragEnd()"
             (click)="addFromPalette('field', p.key)">
          <wf-icon name="grip-vertical" [size]="16" class="grip"></wf-icon>
          <wf-icon [name]="p.meta.icon" [size]="16" class="pi-icon"></wf-icon>
          <span>{{ p.meta.label }}</span>
        </div>

        <div class="palette-group-title">Action Buttons</div>
        <div class="palette-item" [ngClass]="actionColorClass(p.key)" *ngFor="let p of paletteActions"
             draggable="true" (dragstart)="onPaletteDragStart($event, 'action', p.key)" (dragend)="onDragEnd()"
             (click)="addFromPalette('action', p.key)">
          <wf-icon name="grip-vertical" [size]="16" class="grip"></wf-icon>
          <wf-icon [name]="p.meta.icon" [size]="16" class="pi-icon"></wf-icon>
          <span>{{ p.meta.label }}</span>
        </div>
      </div>

      <div class="wf-palette-instruction">
        <wf-icon name="move-diagonal" [size]="13"></wf-icon>
        Drag a field onto the canvas, or tap to add on small screens
      </div>
    </aside>
    <div class="wf-palette-backdrop" *ngIf="paletteOpen" (click)="paletteOpen = false"></div>
  </div>

  <!-- Mobile palette FAB -->
  <button class="palette-fab" (click)="paletteOpen = true">
    <wf-icon name="type" [size]="18"></wf-icon> Add element
  </button>
</div>

<!-- ===================== FIELD CARD TEMPLATE ===================== -->
<ng-template #fieldCard let-entry="entry">
  <ng-container *ngIf="entryField(entry) as field">
    <div class="field-card" [class.mirror-card]="isMirror(entry)"
         [attr.id]="reviewFieldDomId(wf.activeStage, reviewEntryEntityKey(entry))"
         [attr.data-field-id]="field.id" [attr.data-review-key]="reviewEntryEntityKey(entry)"
         [class.review-target]="isReviewFieldTarget(entry)"
         [class.review-target-added]="isReviewFieldTarget(entry) && reviewPreview?.kind === 'added'"
         [class.review-target-changed]="isReviewFieldTarget(entry) && reviewPreview?.kind === 'changed'"
         [class.tall]="field.type === 'longtext' || field.type === 'file'"
         draggable="true" (dragstart)="onCardDragStart($event, entryKey(entry))" (dragend)="onDragEnd()">
      <div class="fc-grid">
        <span class="fc-grip"><wf-icon name="grip-vertical" [size]="16"></wf-icon></span>
        <div class="fc-body">
          <div class="fc-labelrow">
            <span *ngIf="isMirror(entry)" class="fc-label">{{ field.label }}</span>
            <span *ngIf="!isMirror(entry)" class="fc-label editable" contenteditable="true"
                  (blur)="onLabelBlur(field, $event)">{{ field.label }}</span>
            <span *ngIf="field.required" class="req-star">*</span>

            <span *ngIf="isMirror(entry)" class="tag tag-blue">
              <wf-icon name="lock" [size]="11"></wf-icon> Inherited from Stage 1
            </span>
            <span *ngIf="!isMirror(entry) && wf.activeStage > 1" class="tag tag-amber">
              Stage {{ wf.activeStage }} only
            </span>
            <span *ngIf="field.visibility.enabled" class="tag-icon amber" title="Conditional visibility">
              <wf-icon name="eye" [size]="14"></wf-icon>
            </span>
            <span *ngIf="field.guard.enabled" class="tag-icon blue" title="Submission guard">
              <wf-icon name="shield-check" [size]="14"></wf-icon>
            </span>
            <span *ngIf="reviewFieldTypeIsAuto(field)" class="tag tag-purple">Auto</span>
          </div>

          <div class="fc-type">
            {{ reviewFieldTypeLabel(field) }}<span *ngIf="field.options"> · {{ field.options.length }} options</span>
          </div>

          <ng-container *ngTemplateOutlet="fieldPreview; context: { field: field }"></ng-container>
        </div>

        <div class="fc-ctrls">
          <ng-container *ngIf="isMirror(entry); else nativeCtrls">
            <button class="ic-btn danger-hover" title="Remove from this stage"
                    (click)="removeMirrorFromStage(wf.activeStage, mirrorRefId(entry))">
              <wf-icon name="eye-off" [size]="16"></wf-icon>
            </button>
          </ng-container>
          <ng-template #nativeCtrls>
            <button class="ic-btn" title="Required toggle" (click)="toggleRequired(field)">
              <wf-icon [name]="field.required ? 'asterisk' : 'circle-dashed'" [size]="16"
                       [class.req-on]="field.required"></wf-icon>
            </button>
            <button class="ic-btn" title="Configure" (click)="openFieldConfig(field)">
              <wf-icon name="settings-2" [size]="16"></wf-icon>
            </button>
            <button class="ic-btn danger-hover" title="Delete" (click)="deleteEntry(entryKey(entry))">
              <wf-icon name="x" [size]="16"></wf-icon>
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template #savedFieldReviewCard let-field="field" let-removed="removed">
  <div class="review-saved-wrap" data-review-ghost="field"
       [attr.id]="removed ? reviewFieldDomId(wf.activeStage, reviewPreview?.target?.entityKey || '') : null"
       [style.grid-row]="removed ? (reviewPreview?.target?.beforePosition?.row || 0) + 1 : null"
       [style.grid-column]="removed ? (reviewPreview?.target?.beforePosition?.column || 0) + 1 : null">
    <div class="review-saved-heading">
      <span class="review-saved-badge">{{ removed ? 'Removed' : 'Saved version' }}</span>
      <span>{{ reviewSavedPosition() }}</span>
    </div>
    <div class="field-card review-saved-card" [class.tall]="field.type === 'longtext' || field.type === 'file'">
      <div class="fc-grid">
        <span class="fc-grip"><wf-icon name="grip-vertical" [size]="16"></wf-icon></span>
        <div class="fc-body">
          <div class="fc-labelrow">
            <span class="fc-label">{{ field.label }}</span>
            <span *ngIf="field.required" class="req-star">*</span>
            <span *ngIf="reviewSavedFieldIsMirror()" class="tag tag-blue">
              <wf-icon name="lock" [size]="11"></wf-icon> Inherited from Stage 1
            </span>
            <span *ngIf="!reviewSavedFieldIsMirror() && wf.activeStage > 1" class="tag tag-amber">
              Stage {{ wf.activeStage }} only
            </span>
            <span *ngIf="field.visibility.enabled" class="tag-icon amber" title="Conditional visibility">
              <wf-icon name="eye" [size]="14"></wf-icon>
            </span>
            <span *ngIf="field.guard.enabled" class="tag-icon blue" title="Submission guard">
              <wf-icon name="shield-check" [size]="14"></wf-icon>
            </span>
            <span *ngIf="reviewFieldTypeIsAuto(field)" class="tag tag-purple">Auto</span>
            <span class="tag tag-grey">Read only</span>
          </div>
          <div class="fc-type">
            {{ reviewFieldTypeLabel(field) }}<span *ngIf="field.options"> · {{ field.options.length }} options</span>
          </div>
          <ng-container *ngTemplateOutlet="fieldPreview; context: { field: field }"></ng-container>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #fieldPreview let-field="field">
  <div class="wf-preview" [ngSwitch]="field.type">
    <input *ngSwitchCase="'text'" type="text" class="preview-input"
           [attr.placeholder]="field.placeholder || 'Text input'" tabindex="-1" />
    <textarea *ngSwitchCase="'longtext'" rows="2" class="preview-textarea"
              [attr.placeholder]="field.placeholder || 'Long text…'" tabindex="-1"></textarea>
    <input *ngSwitchCase="'number'" type="number" class="preview-input"
           [attr.placeholder]="field.numberCfg?.min ?? ''" tabindex="-1" />
    <select *ngSwitchCase="'dropdown'" class="preview-input" tabindex="-1">
      <option>{{ field.options ? field.options[0] : '' }}</option>
    </select>
    <input *ngSwitchCase="'date'" type="text" class="preview-input" placeholder="DD/MM/YYYY" tabindex="-1" />
    <div *ngSwitchCase="'daterange'" class="preview-range">
      <input type="text" class="preview-input" [attr.placeholder]="field.dateRangeCfg?.startLabel" tabindex="-1" />
      <input type="text" class="preview-input" [attr.placeholder]="field.dateRangeCfg?.endLabel" tabindex="-1" />
    </div>
    <div *ngSwitchCase="'toggle'" class="toggle"></div>
    <div *ngSwitchCase="'file'" class="preview-file">
      Multi-file: {{ field.fileCfg?.types }}, max {{ field.fileCfg?.maxFiles }}<span
        *ngIf="field.fileCfg?.perFileNotes"> · per-file notes</span>
    </div>
    <div *ngSwitchCase="'timestamp'" class="preview-mono"><wf-icon name="clock" [size]="13"></wf-icon> system-generated</div>
    <div *ngSwitchCase="'refnum'" class="preview-mono">{{ refnumSample(field) }}</div>
    <div *ngSwitchCase="'duration'" class="preview-mono">= end − start ({{ field.durationCfg?.unit }})</div>
    <div *ngSwitchCase="'fraction'" class="preview-range">
      <input type="number" class="preview-input" placeholder="0" tabindex="-1" />
      <span class="fraction-slash">/</span>
      <input type="number" class="preview-input" placeholder="0" tabindex="-1" />
    </div>
  </div>
</ng-template>

<!-- ===================== REUSABLE CONDITION BUILDER ===================== -->
<ng-template #condBuilder let-list="list" let-fields="fields">
  <div class="cond-wrap">
    <div class="cond-row" *ngFor="let c of list; let i = index; trackBy: trackByIndex">
      <select *ngIf="i > 0" class="cond-join" [(ngModel)]="c.join" (ngModelChange)="markDirty()">
        <option value="AND">AND</option>
        <option value="OR">OR</option>
      </select>
      <div class="cond-line">
        <select [(ngModel)]="c.fieldId" (ngModelChange)="markDirty()">
          <option value="">— field —</option>
          <option *ngFor="let f of fields" [value]="f.id">{{ f.label }}</option>
        </select>
        <select [(ngModel)]="c.op" (ngModelChange)="markDirty()">
          <option value="equals">equals</option>
          <option value="not_equals">not equals</option>
          <option value="gt">greater than</option>
          <option value="lt">less than</option>
          <option value="contains">contains</option>
        </select>
      </div>
      <div class="cond-line">
        <input type="text" placeholder="value" [(ngModel)]="c.value" (ngModelChange)="markDirty()" />
        <button class="ic-btn danger-hover" (click)="removeCondition(list, i)"><wf-icon name="x" [size]="16"></wf-icon></button>
      </div>
    </div>
    <button class="link-btn" (click)="addCondition(list)">+ Add condition</button>
  </div>
</ng-template>

<!-- ===================== FIELD CONFIG PANEL ===================== -->
<div class="backdrop" [class.open]="fieldPanelOpen" (click)="closeFieldConfig()"></div>
<aside class="slide-over" *ngIf="wf" [class.open]="fieldPanelOpen">
  <div class="so-head">
    <div>
      <div class="so-title">Field Configuration</div>
      <div class="so-sub" *ngIf="cfgField">{{ fieldTypes[cfgField.type].label }}</div>
    </div>
    <button class="so-close" (click)="closeFieldConfig()"><wf-icon name="x" [size]="20"></wf-icon></button>
  </div>

  <div class="so-body" *ngIf="cfgField as field">
    <div class="fld">
      <label>Label</label>
      <input type="text" [(ngModel)]="field.label" (ngModelChange)="markDirty()" />
    </div>
    <div class="fld">
      <label>Placeholder</label>
      <input type="text" [(ngModel)]="field.placeholder" (ngModelChange)="markDirty()" />
    </div>
    <div class="toggle-row">
      <div class="tr-text"><div>Required</div></div>
      <div class="toggle" [class.on]="field.required" (click)="toggleRequired(field)"></div>
    </div>

    <!-- dropdown list type -->
    <div class="fld" *ngIf="field.type === 'dropdown'">
      <label>List type</label>
      <div class="variant-row">
        <button type="button" class="variant-btn"
          [class.active]="(field.dropdownVariant || 'dropdown') === 'single'"
          (click)="setDropdownVariant(field, 'single')">Single-select</button>
        <button type="button" class="variant-btn"
          [class.active]="(field.dropdownVariant || 'dropdown') === 'multi'"
          (click)="setDropdownVariant(field, 'multi')">Multi-select</button>
        <button type="button" class="variant-btn"
          [class.active]="(field.dropdownVariant || 'dropdown') === 'dropdown'"
          (click)="setDropdownVariant(field, 'dropdown')">Dropdown</button>
      </div>
    </div>

    <!-- dropdown options -->
    <div class="fld" *ngIf="field.type === 'dropdown' && field.options">
      <label>Options</label>
      <div class="opt-list" cdkDropList (cdkDropListDropped)="reorderOption(field, $event)">
        <div class="opt-row" *ngFor="let o of field.options; let i = index; trackBy: trackByIndex" cdkDrag>
          <button class="ic-btn opt-drag" cdkDragHandle title="Drag to reorder"><wf-icon name="grip-vertical" [size]="16"></wf-icon></button>
          <input type="text" [(ngModel)]="field.options[i]" (ngModelChange)="markDirty()" />
          <button class="ic-btn danger-hover" (click)="removeOption(field, i)"><wf-icon name="x" [size]="16"></wf-icon></button>
        </div>
      </div>
      <button class="link-btn" (click)="addOption(field)">+ Add option</button>

      <!-- Bulk upload is only available for the Dropdown list variant. -->
      <div class="bulk-upload" *ngIf="(field.dropdownVariant || 'dropdown') === 'dropdown'">
        <label class="sub mt">Or upload options in bulk (CSV, first column)</label>
        <input type="file" accept=".csv" (change)="onDropdownCsvSelected($event, field)" />
      </div>
    </div>

    <!-- number -->
    <div class="fld" *ngIf="field.type === 'number' && field.numberCfg">
      <label>Number constraints</label>
      <div class="grid-3">
        <div><label class="sub">Min</label><input type="number" [(ngModel)]="field.numberCfg.min" (ngModelChange)="markDirty()" /></div>
        <div><label class="sub">Max</label><input type="number" [(ngModel)]="field.numberCfg.max" (ngModelChange)="markDirty()" /></div>
        <div><label class="sub">Decimals</label><input type="number" [(ngModel)]="field.numberCfg.decimals" (ngModelChange)="markDirty()" /></div>
      </div>
    </div>

    <!-- date range -->
    <div class="fld" *ngIf="field.type === 'daterange' && field.dateRangeCfg">
      <label>Date range labels</label>
      <label class="sub">Start label</label>
      <input type="text" [(ngModel)]="field.dateRangeCfg.startLabel" (ngModelChange)="markDirty()" />
      <label class="sub mt">End label</label>
      <input type="text" [(ngModel)]="field.dateRangeCfg.endLabel" (ngModelChange)="markDirty()" />
    </div>

    <!-- file -->
    <div class="fld" *ngIf="field.type === 'file' && field.fileCfg">
      <label>File attachment</label>
      <label class="sub">Allowed types</label>
      <select [(ngModel)]="field.fileCfg.types" (ngModelChange)="markDirty()">
        <option value="any">Any</option>
        <option value="image">Images only</option>
        <option value="audio">Audio only</option>
        <option value="video">Video only</option>
        <option value="image,audio,video">Images + Audio + Video</option>
      </select>
      <div class="grid-2 mt">
        <div><label class="sub">Max files</label><input type="number" [(ngModel)]="field.fileCfg.maxFiles" (ngModelChange)="markDirty()" /></div>
        <div><label class="sub">Max size (MB)</label><input type="number" [(ngModel)]="field.fileCfg.maxSizeMB" (ngModelChange)="markDirty()" /></div>
      </div>
      <div class="toggle-row">
        <div class="tr-text"><div>Per-file notes (each upload gets a supporting note)</div></div>
        <div class="toggle" [class.on]="field.fileCfg.perFileNotes"
             (click)="field.fileCfg.perFileNotes = !field.fileCfg.perFileNotes; markDirty()"></div>
      </div>
    </div>

    <!-- duration -->
    <div class="fld" *ngIf="field.type === 'duration' && field.durationCfg">
      <label>Duration source</label>
      <label class="sub">Start Date field</label>
      <select [(ngModel)]="field.durationCfg.startFieldId" (ngModelChange)="markDirty()">
        <option value="">— select —</option>
        <option *ngFor="let f of dateFieldsInStage()" [value]="f.id">{{ f.label }}</option>
      </select>
      <label class="sub mt">End Date field</label>
      <select [(ngModel)]="field.durationCfg.endFieldId" (ngModelChange)="markDirty()">
        <option value="">— select —</option>
        <option *ngFor="let f of dateFieldsInStage()" [value]="f.id">{{ f.label }}</option>
      </select>
      <p class="hint">Calculated automatically at runtime in days.</p>
    </div>

    <!-- refnum -->
    <div class="fld" *ngIf="field.type === 'refnum' && field.refnumCfg">
      <label>Reference number</label>
      <label class="sub">Prefix</label>
      <input type="text" [(ngModel)]="field.refnumCfg.prefix" (ngModelChange)="markDirty()" />
      <label class="sub mt">Padding digits</label>
      <input type="number" [(ngModel)]="field.refnumCfg.padding" (ngModelChange)="markDirty()" />
    </div>

    <!-- conditional visibility -->
    <div class="so-section">
      <div class="so-section-title"><wf-icon name="eye" [size]="16"></wf-icon> Conditional Visibility</div>
      <div class="so-section-sub">Show this field only when conditions are met.</div>
    </div>
    <div class="toggle-row">
      <div class="tr-text"><div>Only show this field when…</div></div>
      <div class="toggle" [class.on]="field.visibility.enabled"
           (click)="field.visibility.enabled = !field.visibility.enabled; markDirty()"></div>
    </div>
    <ng-container *ngIf="field.visibility.enabled">
      <ng-container *ngTemplateOutlet="condBuilder; context: { list: field.visibility.conditions, fields: visibilitySourceFields(field) }"></ng-container>
    </ng-container>

    <!-- submission guard -->
    <div class="so-section">
      <div class="so-section-title"><wf-icon name="shield-check" [size]="16"></wf-icon> Submission Guard</div>
      <div class="so-section-sub">Block submission if a record already exists matching the key.</div>
    </div>
    <div class="toggle-row">
      <div class="tr-text"><div>Enable duplicate detection</div></div>
      <div class="toggle" [class.on]="field.guard.enabled"
           (click)="toggleGuard(field)"></div>
    </div>
    <div class="check-list" *ngIf="field.guard.enabled">
      <label class="sub">Duplicate key fields (matching combo blocks submission)</label>
      <label class="check-row" *ngFor="let f of guardKeyFields()">
        <input type="checkbox" [checked]="field.guard.keys.includes(f.id)" (change)="toggleGuardKey(field, f.id)" />
        <span>{{ f.label }}</span>
      </label>
    </div>
  </div>
</aside>

<!-- ===================== STAGE ROUTING PANEL ===================== -->
<div class="backdrop" [class.open]="routingPanelOpen" (click)="closeRouting()"></div>
<aside class="slide-over" *ngIf="wf" [class.open]="routingPanelOpen">
  <div class="so-head">
    <div>
      <div class="so-title">Stage Routing</div>
      <div class="so-sub">{{ stageDisplayName(wf.activeStage) }} of {{ wf.stageCount }}</div>
    </div>
    <button class="so-close" (click)="closeRouting()"><wf-icon name="x" [size]="20"></wf-icon></button>
  </div>

  <div class="so-body" *ngIf="routingPanelOpen">
    <ng-container *ngIf="activeStage.routing as r">
      <div class="fld">
        <label>Stage Name</label>
        <input type="text" [(ngModel)]="activeStage.name" (ngModelChange)="markDirty()"
               (blur)="onStageNameBlur()" [placeholder]="'Stage ' + wf.activeStage" maxlength="80" />
        <p class="inline-error" *ngIf="!activeStage.name || !activeStage.name.trim()">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Stage name is required
        </p>
        <p class="inline-error" *ngIf="activeStage.name && activeStage.name.trim() && activeStage.name.trim().length < 3">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Stage name must be at least 3 characters
        </p>
        <p class="inline-error" *ngIf="activeStage.name && isStageNameDuplicate(wf.activeStage)">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> A stage with this name already exists
        </p>
      </div>

      <div class="fld">
        <div class="fld-label-row">
          <label>Actor Roles</label>
          <button type="button" class="manage-roles-btn" (click)="openRoleModal()">
            <wf-icon name="settings-2" [size]="13"></wf-icon> Manage roles
          </button>
        </div>
        <select class="actor-role-select" [ngModel]="getActorRole(r)"
                (ngModelChange)="setActorRole(r, $event)">
          <option value="">— Select an actor role —</option>
          <option *ngFor="let role of actorRoleOptions(r)" [value]="role">
            {{ role }}{{ isRoleDeactivated(role) ? ' (deactivated)' : '' }}
          </option>
        </select>
        <p class="hint">One actor role acts on this stage.</p>
        <p class="inline-error" *ngIf="r.actorRoles.length === 0">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> At least one actor role is required for each stage
        </p>
        <p class="inline-error" *ngIf="stageHasDeactivatedRole(wf.activeStage)">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> A deactivated role is assigned — replace it to continue
        </p>
      </div>

      <div class="so-section-title plain">Notification Types</div>
      <div class="toggle-row" id="rt-notifications-transition">
        <div class="tr-text"><div>Stage Transition (default)</div></div>
        <div class="toggle" [class.on]="r.notifications.transition"
             (click)="r.notifications.transition = !r.notifications.transition; markDirty()"></div>
      </div>
      <div class="toggle-row" id="rt-notifications-perItem">
        <div class="tr-text"><div>Per-Item Notification</div></div>
        <div class="toggle" [class.on]="r.notifications.perItem"
             (click)="r.notifications.perItem = !r.notifications.perItem; markDirty()"></div>
      </div>
      <div class="sub-panel" *ngIf="r.notifications.perItem">
        <label class="sub">Recipient field (e.g. "Host / Contact")</label>
        <select [(ngModel)]="r.notifications.perItemRecipientField" (ngModelChange)="markDirty()">
          <option value="">— select —</option>
          <option *ngFor="let f of perItemRecipientFields()" [value]="f.id">{{ f.label }}</option>
        </select>
        <label class="sub mt">Trigger event label</label>
        <input type="text" [(ngModel)]="r.notifications.perItemEventLabel" (ngModelChange)="markDirty()" placeholder="e.g. Your visitor has arrived" />
      </div>
      <div class="toggle-row" id="rt-notifications-reminder">
        <div class="tr-text"><div>Reminder Notification</div></div>
        <div class="toggle" [class.on]="r.notifications.reminder"
             (click)="r.notifications.reminder = !r.notifications.reminder; markDirty()"></div>
      </div>
      <div class="sub-panel" *ngIf="r.notifications.reminder">
        <label class="sub">Submission schedule</label>
        <select [(ngModel)]="r.notifications.reminderSchedule" (ngModelChange)="markDirty()">
          <option value="daily">daily</option>
          <option value="weekly">weekly</option>
          <option value="fortnightly">fortnightly</option>
        </select>
        <label class="sub mt">Reminder time</label>
        <input type="text" [(ngModel)]="r.notifications.reminderTime" (ngModelChange)="markDirty()" />
      </div>
      <div class="toggle-row" id="rt-notifications-escalation">
        <div class="tr-text"><div>Escalation Notification (fires when Time Budget exceeded)</div></div>
        <div class="toggle" [class.on]="r.notifications.escalation"
             (click)="r.notifications.escalation = !r.notifications.escalation; markDirty()"></div>
      </div>

      <!-- per-stage notification channels (channel x trigger x recipient role) -->
      <div class="so-section-title plain" id="rt-notifications-rules">Notification Channels</div>
      <!-- non-blocking banner when the notification template service is unreachable -->
      <div class="so-banner warn" *ngIf="notificationTemplatesUnavailable">
        <wf-icon name="alert-triangle" [size]="14"></wf-icon>
        Notification templates unavailable — defaults will be used
      </div>
      <p class="hint" *ngIf="r.notifications.rules.length === 0">
        No channel notifications configured for this stage.
      </p>
      <div class="notif-rule" *ngFor="let rule of r.notifications.rules; let idx = index; trackBy: trackByNotificationRule">
        <div class="notif-rule-head">
          <span class="notif-rule-title">Notification {{ idx + 1 }}</span>
          <button class="ic-btn danger-hover" title="Remove notification"
                  (click)="removeNotificationRule(r, rule.id)">
            <wf-icon name="x" [size]="15"></wf-icon>
          </button>
        </div>
        <div class="nr-row">
          <div class="nr-fld">
            <label class="sub">Channel</label>
            <select [(ngModel)]="rule.channel" (ngModelChange)="markDirty()">
              <option *ngFor="let c of notificationChannels" [value]="c.value">{{ c.label }}</option>
            </select>
          </div>
          <div class="nr-fld">
            <label class="sub">Trigger</label>
            <select [(ngModel)]="rule.trigger" (ngModelChange)="markDirty()">
              <option *ngFor="let t of notificationTriggers" [value]="t.value">{{ t.label }}</option>
            </select>
          </div>
        </div>
        <div class="nr-fld">
          <label class="sub">Recipient role</label>
          <select [(ngModel)]="rule.recipientRole" (ngModelChange)="markDirty()">
            <option value="">— select —</option>
            <option *ngFor="let role of orderedRoles()" [value]="role">{{ role }}</option>
          </select>
        </div>
        <p class="inline-error" *ngIf="rule.channel === 'email' && !rule.recipientRole">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Email notifications require a recipient role
        </p>
        <p class="inline-error" *ngIf="rule.channel === 'email' && rule.recipientRole && unresolvableEmailRoles.has(rule.recipientRole)">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> This role has no users — recipients can't be resolved
        </p>
        <p class="inline-error" *ngIf="isDuplicateNotificationRule(r, rule)">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Duplicate of another notification on this stage
        </p>
      </div>
      <button class="add-link" [disabled]="!canAddNotificationRule(r)" (click)="addNotificationRule(r)">
        <wf-icon name="plus" [size]="14"></wf-icon> Add notification
      </button>
      <p class="hint" *ngIf="!canAddNotificationRule(r) && r.notifications.rules.length > 0">
        Resolve the highlighted notification (pick a recipient role and remove duplicates) before adding another.
      </p>

      <div class="fld" id="rt-timeBudget">
        <label>Time Budget</label>
        <div class="tb-row">
          <input type="number" min="0" [(ngModel)]="r.timeBudget.value"
                 (ngModelChange)="onTimeBudgetChange(r)" />
          <select [(ngModel)]="r.timeBudget.unit" (ngModelChange)="markDirty()">
            <option value="minutes">minutes</option>
            <option value="hours">hours</option>
            <option value="days">days</option>
          </select>
        </div>
        <p class="hint">Currently: {{ r.timeBudget.value }} {{ r.timeBudget.unit }}</p>
        <p class="inline-error" *ngIf="isTimeBudgetInvalid(r.timeBudget.value)">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Time budget must be a positive number
        </p>
      </div>

      <div class="fld" id="rt-escalationTarget">
        <div class="fld-label-row">
          <label>Escalation Target Role Type</label>
          <span class="assign-chip">Set at Assignment</span>
        </div>
        <select [(ngModel)]="r.escalationTarget" (ngModelChange)="markDirty()">
          <option value="">— select —</option>
          <option *ngFor="let role of orderedRoles()" [value]="role">{{ role }}</option>
        </select>
        <p class="hint">Declares a supervisor-type role slot. The named user or group is resolved against the tenant directory at assignment.</p>
        <p class="inline-error" *ngIf="stageHasEscalate(activeStage) && !r.escalationTarget">
          <wf-icon name="alert-triangle" [size]="13"></wf-icon> Escalation target is required when Escalate is enabled
        </p>
      </div>

      <!-- approval routing -->
      <ng-container *ngIf="stageHasApprove(activeStage)">
        <div class="so-section" id="rt-approvalTarget">
          <div class="so-section-title"><wf-icon name="check-check" [size]="16"></wf-icon> Approval Routing</div>
          <div class="so-section-sub">Where approved items go from this stage.</div>
        </div>
        <div class="fld">
          <label>On approve</label>
          <select [(ngModel)]="r.approvalTarget.type" (ngModelChange)="onApprovalTypeChange(r)">
            <option value="next" *ngIf="wf.activeStage < wf.stageCount">Advance to next stage</option>
            <option value="stage" *ngIf="laterStageIndices().length > 0">Advance to specific stage…</option>
            <option value="close">Close as Approved</option>
            <option value="output" *ngIf="wf.activeStage === wf.stageCount">Trigger Final Stage Output</option>
          </select>
        </div>
        <div class="fld" *ngIf="r.approvalTarget.type === 'stage'">
          <label>Target stage</label>
          <select [(ngModel)]="r.approvalTarget.stage" (ngModelChange)="markDirty()">
            <option [ngValue]="null">— select —</option>
            <option *ngFor="let i of laterStageIndices()" [ngValue]="i">{{ stageDisplayName(i) }}</option>
          </select>
        </div>
      </ng-container>

      <!-- rejection routing -->
      <ng-container *ngIf="stageHasReject(activeStage)">
        <div class="so-section" id="rt-rejectionTarget">
          <div class="so-section-title"><wf-icon name="x" [size]="16"></wf-icon> Rejection Routing</div>
          <div class="so-section-sub">Where rejected items go from this stage.</div>
        </div>
        <div class="fld">
          <label>On reject</label>
          <select [(ngModel)]="r.rejectionTarget.type" (ngModelChange)="markDirty()">
            <option value="">— select —</option>
            <option value="previous" *ngIf="wf.activeStage > 1">Return to previous stage (rework)</option>
            <option value="close">Close as Rejected</option>
          </select>
          <p class="hint" *ngIf="wf.activeStage === 1">Stage 1 cannot reject to a previous stage.</p>
          <p class="inline-error" *ngIf="!r.rejectionTarget.type">Stage {{ wf.activeStage }} is missing a rejection target</p>
        </div>
      </ng-container>

      <!-- conditional routing -->
      <ng-container *ngIf="wf.activeStage > 1">
        <div class="so-section" id="rt-conditionalRoute">
          <div class="so-section-title"><wf-icon name="zap" [size]="16"></wf-icon> Conditional Stage Routing</div>
          <div class="so-section-sub">Only route to this stage when criteria are met.</div>
        </div>
        <div class="toggle-row">
          <div class="tr-text"><div>Only route to this stage when…</div></div>
          <div class="toggle" [class.on]="r.conditionalRoute.enabled"
               (click)="r.conditionalRoute.enabled = !r.conditionalRoute.enabled; markDirty()"></div>
        </div>
        <ng-container *ngIf="r.conditionalRoute.enabled">
          <ng-container *ngTemplateOutlet="condBuilder; context: { list: r.conditionalRoute.conditions, fields: earlierStageFields() }"></ng-container>
        </ng-container>
      </ng-container>

      <!-- 2nd approver -->
      <div class="toggle-row" id="rt-secondApprover" *ngIf="wf.activeStage >= 2">
        <div class="tr-text">
          <div>Designate as 2nd Approver stage</div>
          <div class="tr-hint">Actors at this stage are treated as 2nd Approvers for approval chain tracking and KPI reporting.</div>
        </div>
        <div class="toggle" [class.on]="r.secondApprover"
             (click)="r.secondApprover = !r.secondApprover; markDirty()"></div>
      </div>

      <!-- immutability -->
      <div class="toggle-row" id="rt-immutable">
        <div class="tr-text">
          <div>Submitted records are immutable (additive only)</div>
          <div class="tr-hint">All additions are logged with actor identity and timestamp.</div>
        </div>
        <div class="toggle" [class.on]="r.immutable" (click)="r.immutable = !r.immutable; markDirty()"></div>
      </div>

      <!-- final stage outputs -->
      <ng-container *ngIf="isFinalStage">
        <div class="so-section" id="rt-finalOutputs">
          <div class="so-section-title"><wf-icon name="file-output" [size]="16"></wf-icon> Final Stage Outputs</div>
          <div class="so-section-sub">Artefacts produced when the workflow closes as Approved.</div>
        </div>
        <div class="toggle-row" id="rt-finalOutputs-pdf">
          <div class="tr-text"><div>Generate PDF report</div></div>
          <div class="toggle" [class.on]="wf.finalOutputs.pdf.enabled"
               (click)="wf.finalOutputs.pdf.enabled = !wf.finalOutputs.pdf.enabled; markDirty()"></div>
        </div>
        <div class="sub-panel" *ngIf="wf.finalOutputs.pdf.enabled">
          <label class="sub">PDF template</label>
          <select [(ngModel)]="wf.finalOutputs.pdf.template" (ngModelChange)="markDirty()">
            <option value="Default">Default</option>
            <option value="Compliance">Compliance</option>
            <option value="Summary">Summary</option>
          </select>
        </div>
        <div class="toggle-row" id="rt-finalOutputs-email">
          <div class="tr-text"><div>Send email notification</div></div>
          <div class="toggle" [class.on]="wf.finalOutputs.email.enabled"
               (click)="wf.finalOutputs.email.enabled = !wf.finalOutputs.email.enabled; markDirty()"></div>
        </div>
        <div class="sub-panel" *ngIf="wf.finalOutputs.email.enabled">
          <label class="sub">Recipient role(s)</label>
          <label class="check-row" *ngFor="let role of orderedRoles()">
            <input type="checkbox" [checked]="wf.finalOutputs.email.recipients.includes(role)"
                   (change)="toggleEmailRecipient(role)" />
            <span>{{ role }}</span>
          </label>
        </div>
      </ng-container>

      <!-- retention -->
      <div class="so-section" id="rt-retention"><div class="so-section-title plain">Data Retention</div></div>
      <div class="toggle-row">
        <div class="tr-text"><div>Store records to central database</div></div>
        <div class="toggle" [class.on]="r.retention.store"
             (click)="r.retention.store = !r.retention.store; markDirty()"></div>
      </div>
      <div class="sub-panel" *ngIf="r.retention.store">
        <label class="sub">Retention window (days)</label>
        <input type="number" [(ngModel)]="r.retention.days" (ngModelChange)="markDirty()" />
        <div class="toggle-row">
          <div class="tr-text"><div>Auto-purge after window</div></div>
          <div class="toggle" [class.on]="r.retention.autoPurge"
               (click)="r.retention.autoPurge = !r.retention.autoPurge; markDirty()"></div>
        </div>
      </div>
    </ng-container>
  </div>
</aside>

<!-- ===================== VALIDATION PANEL ===================== -->
<div class="backdrop" [class.open]="validationPanelOpen" (click)="closeValidation()"></div>
<aside class="slide-over" *ngIf="wf" [class.open]="validationPanelOpen">
  <div class="so-head">
    <div>
      <div class="so-title">Validation Results</div>
      <div class="so-sub" *ngIf="wf.lastValidation">
        <ng-container *ngIf="wf.lastValidation.passed">✓ All rules passed — ready to publish</ng-container>
        <ng-container *ngIf="!wf.lastValidation.passed">{{ failedRuleCount }} of {{ wf.lastValidation.rules.length }} rules failed</ng-container>
      </div>
    </div>
    <button class="so-close" (click)="closeValidation()"><wf-icon name="x" [size]="20"></wf-icon></button>
  </div>
  <div class="so-body" *ngIf="wf.lastValidation as v">
    <div class="vr-summary" [class.pass]="v.passed" [class.fail]="!v.passed">
      <ng-container *ngIf="v.passed">
        <div class="vr-summary-title"><wf-icon name="check-circle-2" [size]="20"></wf-icon> Workflow is valid</div>
        <div class="vr-summary-sub">You can now publish this workflow.</div>
      </ng-container>
      <ng-container *ngIf="!v.passed">
        <div class="vr-summary-title"><wf-icon name="x-circle" [size]="20"></wf-icon> Validation failed</div>
        <div class="vr-summary-sub">Fix the issues below before publishing.</div>
      </ng-container>
    </div>

    <div class="validate-rule" *ngFor="let rule of v.rules" [class.pass]="rule.pass" [class.fail]="!rule.pass"
         (click)="!rule.pass && gotoRule(rule)">
      <wf-icon [name]="rule.pass ? 'check' : 'x'" [size]="16" class="vr-icon"></wf-icon>
      <div class="vr-text">
        <div class="vr-label">{{ rule.pass ? rule.label : rule.failMessage }}</div>
        <div class="vr-link" *ngIf="!rule.pass">Go to Stage {{ rule.stage }} →</div>
      </div>
    </div>
  </div>
</aside>

<!-- ===================== HISTORY PANEL ===================== -->
<div class="backdrop" [class.open]="historyPanelOpen" (click)="closeHistory()"></div>
<aside class="slide-over wide" *ngIf="wf && canViewAuditLog" [class.open]="historyPanelOpen">
  <div class="so-head col">
    <div class="so-head-top">
      <div>
        <div class="so-title">History — Audit Log</div>
        <div class="so-sub">Chronological record of all workflow changes</div>
      </div>
      <button class="so-close" (click)="closeHistory()"><wf-icon name="x" [size]="20"></wf-icon></button>
    </div>
    <div class="hist-filters">
      <span class="hf-label">Filter:</span>
      <span class="filter-chip" [class.active]="histFilter === 'ALL'" (click)="setHistFilter('ALL')">All</span>
      <span class="filter-chip" [class.active]="histFilter === 'CREATE'" (click)="setHistFilter('CREATE')">Create</span>
      <span class="filter-chip" [class.active]="histFilter === 'UPDATE'" (click)="setHistFilter('UPDATE')">Update</span>
      <span class="filter-chip" [class.active]="histFilter === 'PUBLISH'" (click)="setHistFilter('PUBLISH')">Publish</span>
      <span class="filter-chip" [class.active]="histFilter === 'DEACTIVATE'" (click)="setHistFilter('DEACTIVATE')">Deactivate</span>
      <button class="export-btn" (click)="exportAudit()"><wf-icon name="download" [size]="14"></wf-icon> Export CSV</button>
      <button class="export-btn" (click)="exportAuditPdf()"><wf-icon name="file-text" [size]="14"></wf-icon> Export PDF</button>
    </div>
    <div class="hist-filters">
      <span class="hf-label">User:</span>
      <select class="hist-select" [(ngModel)]="histUser" (ngModelChange)="onHistoryFilterChanged()">
        <option value="">All users</option>
        <option *ngFor="let u of historyUsers" [value]="u">{{ u }}</option>
      </select>
      <span class="hf-label">From:</span>
      <input class="hist-date" type="date" [(ngModel)]="histFrom" (ngModelChange)="onHistoryFilterChanged()" />
      <span class="hf-label">To:</span>
      <input class="hist-date" type="date" [(ngModel)]="histTo" (ngModelChange)="onHistoryFilterChanged()" />
      <button class="filter-chip" (click)="clearHistFilters()">Clear</button>
    </div>
  </div>
  <div class="so-body">
    <div class="hist-empty" *ngIf="auditLoading">Loading audit log…</div>
    <div class="hist-empty" *ngIf="!auditLoading && auditLoadError">{{ auditLoadError }}</div>
    <div class="hist-empty" *ngIf="!auditLoading && !auditLoadError && historyEntries.length === 0">No audit entries match the current filter.</div>
    <div class="history-row" *ngFor="let e of historyEntries; trackBy: trackByAudit">
      <div class="hr-top">
        <span class="action" [ngClass]="'action-' + e.action">{{ e.action }}</span>
        <span class="hr-entity">{{ entityTypeLabel(e.entityType) }}</span>
        <span class="hr-summary">{{ auditSummary(e) }}</span>
      </div>
      <div class="meta">
        <span><wf-icon name="user" [size]="12"></wf-icon> {{ e.userId }}</span>
        <span>{{ e.ts | date: 'medium' }}</span>
        <span class="reason" *ngIf="e.reason">"{{ e.reason }}"</span>
      </div>
      <details class="hr-diff" *ngIf="hasAuditChanges(e)">
        <summary>View details</summary>
        <div class="diff-list">
          <div class="diff-row" *ngFor="let c of auditChanges(e)" [ngClass]="'diff-' + c.kind">
            <span class="diff-label">{{ c.label }}</span>
            <span class="diff-values">
              <ng-container *ngIf="c.kind === 'snapshot'">
                <span class="diff-after">{{ formatAuditValue(c.after) }}</span>
              </ng-container>
              <ng-container *ngIf="c.kind === 'added'">
                <span class="diff-after">{{ formatAuditValue(c.after) }}</span>
              </ng-container>
              <ng-container *ngIf="c.kind === 'removed'">
                <span class="diff-before">{{ formatAuditValue(c.before) }}</span>
              </ng-container>
              <ng-container *ngIf="c.kind === 'changed'">
                <span class="diff-before">{{ formatAuditValue(c.before) }}</span>
                <span class="diff-arrow">→</span>
                <span class="diff-after">{{ formatAuditValue(c.after) }}</span>
              </ng-container>
            </span>
          </div>
        </div>
      </details>
    </div>
  </div>
</aside>

<!-- ===================== REVIEW CHANGES PANEL ===================== -->
<div class="review-backdrop" [class.open]="reviewPanelOpen" (click)="closeReview()"></div>
<aside class="review-panel" *ngIf="wf" [class.open]="reviewPanelOpen" aria-label="Review draft changes"
       [attr.aria-hidden]="reviewPanelOpen ? null : 'true'" [attr.inert]="reviewPanelOpen ? null : ''">
  <header class="review-head">
    <div class="review-head-main">
      <span class="review-head-icon"><wf-icon name="file-text" [size]="19"></wf-icon></span>
      <div>
        <div class="review-title-row">
          <h2>Review draft changes</h2>
          <span class="review-count">{{ reviewChangeCount }}</span>
        </div>
        <p>Compared with saved version v{{ wf.version }} of “{{ savedWorkflowName() }}”</p>
      </div>
      <button class="review-close" (click)="closeReview()" aria-label="Close review">
        <wf-icon name="x" [size]="20"></wf-icon>
      </button>
    </div>
    <div class="review-hint">
      <wf-icon name="mouse-pointer-2" [size]="15"></wf-icon>
      Hover or focus a change to locate it on the workflow.
    </div>
  </header>

  <div class="review-body">
    <div class="review-empty" *ngIf="reviewChangeCount === 0">
      <span><wf-icon name="check-circle-2" [size]="22"></wf-icon></span>
      <strong>Your draft matches the saved version</strong>
      <p>There are no unsaved changes to review.</p>
    </div>

    <section class="review-group" *ngFor="let group of reviewGroups; trackBy: trackByReviewGroup">
      <div class="review-group-heading">
        <h3>{{ group.label }}</h3>
        <span>{{ group.cards.length }}</span>
      </div>

      <article class="review-change-card" *ngFor="let card of group.cards; trackBy: trackByReviewCard"
              [ngClass]="'review-card-' + card.kind" [class.active]="reviewPreview?.id === card.id"
              [attr.data-review-path]="card.changes[0].path"
              [attr.data-review-card-id]="card.id"
              (mouseenter)="onReviewCardEnter(card)" (mouseleave)="onReviewCardLeave(card)"
              >
        <button type="button" class="review-card-main"
                (click)="activateReviewCard(card)"
                (focus)="onReviewCardFocus(card)" (blur)="onReviewCardBlur(card)">
        <span class="review-card-top">
          <span class="review-card-title">
            <span class="review-status-dot" aria-hidden="true"></span>
            <strong>{{ card.label }}</strong>
          </span>
          <span class="review-status">{{ reviewCardStatus(card) }}</span>
        </span>

        <span class="review-card-time" *ngIf="reviewCardTime(card)">
          <wf-icon name="clock" [size]="12"></wf-icon> {{ reviewCardTime(card) }}
        </span>

        <ng-container *ngIf="card.view?.structured; else comparisonProps">
          <span class="review-summary">
            <span class="review-summary-line" *ngFor="let line of card.view?.summaryLines">{{ line }}</span>
          </span>
          <span class="review-details-toggle" *ngIf="card.view?.details?.length"
                [class.expanded]="isReviewCardExpanded(card)"
                (click)="toggleReviewCardDetails(card, $event)">
            <wf-icon name="chevron-down" [size]="14"></wf-icon>
            {{ isReviewCardExpanded(card) ? 'Hide details' : 'View details' }}
          </span>
          <span class="review-details" *ngIf="isReviewCardExpanded(card)">
            <span class="review-detail-row" *ngFor="let detail of card.view?.details">
              <span class="review-detail-label">{{ detail.label }}</span>
              <span class="review-detail-value" *ngIf="detail.value">{{ detail.value }}</span>
              <span class="review-detail-list" *ngIf="detail.values">
                <span class="review-detail-item" *ngFor="let item of detail.values">{{ item }}</span>
              </span>
            </span>
          </span>
        </ng-container>

        <ng-template #comparisonProps>
          <span class="review-properties">
            <span class="review-property" *ngFor="let change of card.changes">
              <span class="review-property-name">{{ reviewPropertyLabel(change, card) }}</span>
              <span class="review-value-grid">
                <span class="review-value review-value-saved">
                  <small>Saved</small>
                  <span [class.review-not-present]="change.kind === 'added'">
                    {{ change.kind === 'added' ? 'Not added' : resolveReviewValue(change.path, change.before, 'saved') }}
                  </span>
                </span>
                <span class="review-value-arrow" aria-hidden="true">→</span>
                <span class="review-value review-value-draft">
                  <small>Draft</small>
                  <span [class.review-not-present]="change.kind === 'removed'">
                    {{ change.kind === 'removed' ? 'Not added' : resolveReviewValue(change.path, change.after, 'draft') }}
                  </span>
                </span>
              </span>
            </span>
          </span>
        </ng-template>
        <span class="review-show-on-canvas"><wf-icon name="mouse-pointer-2" [size]="13"></wf-icon> Show on workflow</span>
        </button>
        <button type="button" class="review-revert" title="Revert change"
                [attr.aria-label]="'Revert change: ' + card.label"
                [disabled]="revertingCardId !== null"
                (click)="requestRevertChange(card, $event)">
          <wf-icon name="undo-2" [size]="15"></wf-icon>
        </button>
      </article>
    </section>
  </div>

  <footer class="review-foot" *ngIf="reviewChangeCount > 0">
    <button class="top-btn danger review-discard" [disabled]="saving" (click)="discardFromReview()">Discard changes</button>
    <span class="review-foot-actions">
      <button class="top-btn" (click)="closeReview()">Continue editing</button>
      <button class="top-btn success" *ngIf="!isActive && !isInactive" [disabled]="saving" (click)="saveFromReview()">Save draft</button>
    </span>
  </footer>
</aside>

<!-- ===================== LEAVE (UNSAVED CHANGES) MODAL ===================== -->
<div class="confirm-modal leave-confirm-modal" *ngIf="leaveModalOpen" (click)="leaveStay()">
  <div class="confirm-modal-card" (click)="$event.stopPropagation()">
    <div class="cm-top">
      <div class="cm-icon"><wf-icon name="alert-triangle" [size]="20"></wf-icon></div>
      <div class="cm-body">
        <h3 class="cm-title">Leave workflow?</h3>
        <p class="cm-text">
          "{{ wf.name }}" has {{ leaveChangeCount }} unsaved {{ leaveChangeCount === 1 ? 'change' : 'changes' }}.
          If you leave now, {{ leaveChangeCount === 1 ? 'this change' : 'these changes' }} will be discarded. The next time you open this workflow, you will see the last saved version.
        </p>
      </div>
    </div>
    <div class="cm-actions">
      <button class="top-btn" (click)="leaveStay()">Continue editing</button>
      <button class="top-btn danger" (click)="discardFromLeaveModal()">Discard changes</button>
      <button class="top-btn primary" (click)="reviewFromLeaveModal()">Review changes</button>
    </div>
  </div>
</div>

<!-- ===================== ASSIGN WORKFLOW MODAL ===================== -->
<div class="aw-backdrop" *ngIf="assignModalOpen && wf" (click)="closeAssign()">
  <div class="aw-card" (click)="$event.stopPropagation()">
    <div class="aw-head">
      <div>
        <h2 class="aw-title">Assign Workflow</h2>
        <div class="aw-sku">{{ wf.sku }} &nbsp;{{ wf.name }}</div>
      </div>
      <button class="aw-close" type="button" aria-label="Close" (click)="closeAssign()">
        <wf-icon name="x" [size]="20"></wf-icon>
      </button>
    </div>

    <div class="aw-body">
      <!-- Account Holder -->
      <div class="aw-field">
        <label>Account Holder</label>
        <div class="aw-select">
          <select [(ngModel)]="accountHolderId" [disabled]="companiesLoading" (ngModelChange)="onAccountHolderChange()">
            <option [ngValue]="null" disabled>Select account holder</option>
            <option *ngFor="let c of companies" [ngValue]="c.companyId">{{ c.companyName }}</option>
          </select>
          <wf-icon name="chevron-down" [size]="18"></wf-icon>
        </div>
      </div>

      <!-- Client (the account holder's plants) -->
      <div class="aw-field">
        <label>Client</label>
        <div class="aw-select">
          <select [(ngModel)]="clientPlantId" [disabled]="accountHolderId == null || clientsLoading"
                  (ngModelChange)="onClientChange()">
            <option [ngValue]="null" disabled>
              {{ clientsLoading ? 'Loading clients…' : 'Choose Client' }}
            </option>
            <option *ngFor="let p of clients" [ngValue]="p.plantId">{{ p.plantName }}</option>
          </select>
          <wf-icon name="chevron-down" [size]="18"></wf-icon>
        </div>
        <p class="aw-error" *ngIf="companyLoadError">{{ companyLoadError }}</p>
        <p class="aw-error" *ngIf="clientsError">{{ clientsError }}</p>
      </div>

      <!-- Select Groups (searchable multi-select) -->
      <div class="aw-field">
        <label>Select Group(s)</label>
        <div class="aw-group-wrap" (click)="$event.stopPropagation()">
          <div class="aw-group-input" [class.open]="groupDropdownOpen">
            <wf-icon name="search" [size]="16"></wf-icon>
            <input type="text" [(ngModel)]="groupSearch"
                   [placeholder]="groupsLoading ? 'Loading groups…' : 'Search'"
                   (focus)="openGroupDropdown()" (click)="openGroupDropdown()" />
          </div>
          <div class="aw-group-menu" *ngIf="groupDropdownOpen">
            <div class="aw-group-empty" *ngIf="groupsLoading">Loading groups…</div>
            <div class="aw-group-empty" *ngIf="!groupsLoading && groupsError">{{ groupsError }}</div>
            <ng-container *ngIf="!groupsLoading && !groupsError">
              <button type="button" class="aw-group-opt" *ngFor="let g of filteredGroups"
                      [class.sel]="isGroupSelected(g)" (click)="toggleGroup(g)">
                <span>{{ g.name }}</span>
                <wf-icon *ngIf="isGroupSelected(g)" name="check" [size]="16"></wf-icon>
              </button>
              <div class="aw-group-empty" *ngIf="filteredGroups.length === 0">No groups found.</div>
            </ng-container>
          </div>
        </div>

        <div class="aw-selected" *ngIf="selectedGroups.length">
          <div class="aw-selected-label">Selected ({{ selectedGroups.length }})</div>
          <div class="aw-chips">
            <span class="aw-chip" *ngFor="let g of selectedGroups">
              {{ g.name }}
              <button type="button" aria-label="Remove" (click)="removeGroup(g, $event)">×</button>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="aw-foot">
      <button class="aw-cancel" type="button" (click)="closeAssign()">Cancel</button>
      <button class="aw-assign" type="button" [disabled]="assignSaving || !canAssign" (click)="assignWorkflow()">
        {{ assignSaving ? 'Saving…' : 'Assign workflow' }}
      </button>
    </div>
  </div>
</div>

<!-- ===================== SCHEDULE WORKFLOW MODAL ===================== -->
<div class="aw-backdrop" *ngIf="scheduleModalOpen && wf" (click)="closeSchedule()">
  <div class="aw-card" (click)="$event.stopPropagation()">
    <div class="aw-head">
      <div>
        <h2 class="aw-title">Schedule Workflow</h2>
        <div class="aw-sku">{{ wf.sku }} &nbsp;{{ wf.name }}</div>
      </div>
      <button class="aw-close" type="button" aria-label="Close" (click)="closeSchedule()">
        <wf-icon name="x" [size]="20"></wf-icon>
      </button>
    </div>

    <div class="aw-body">
      <div class="aw-warn" *ngIf="!isWorkflowSchedulable">
        <wf-icon name="alert-triangle" [size]="16"></wf-icon>
        <span>Publish this workflow first — only a published workflow can be scheduled. Use <strong>Save Options</strong> above to save &amp; publish, then reopen Schedule.</span>
      </div>

      <!-- Account Holder -->
      <div class="aw-field">
        <label>Account Holder</label>
        <div class="aw-select">
          <select [(ngModel)]="accountHolderId" [disabled]="companiesLoading" (ngModelChange)="onAccountHolderChange()">
            <option [ngValue]="null" disabled>Select account holder</option>
            <option *ngFor="let c of companies" [ngValue]="c.companyId">{{ c.companyName }}</option>
          </select>
          <wf-icon name="chevron-down" [size]="18"></wf-icon>
        </div>
      </div>

      <!-- Client -->
      <div class="aw-field">
        <label>Client</label>
        <div class="aw-select">
          <select [(ngModel)]="clientPlantId" [disabled]="accountHolderId == null || clientsLoading"
                  (ngModelChange)="onClientChange(); activeGroup = null">
            <option [ngValue]="null" disabled>
              {{ clientsLoading ? 'Loading clients…' : 'Choose Client' }}
            </option>
            <option *ngFor="let p of clients" [ngValue]="p.plantId">{{ p.plantName }}</option>
          </select>
          <wf-icon name="chevron-down" [size]="18"></wf-icon>
        </div>
        <p class="aw-error" *ngIf="companyLoadError">{{ companyLoadError }}</p>
        <p class="aw-error" *ngIf="clientsError">{{ clientsError }}</p>
      </div>

      <!-- Group (single) -->
      <div class="aw-field">
        <label>Group</label>
        <div class="aw-select">
          <select [(ngModel)]="activeGroup" [disabled]="clientPlantId == null || groupsLoading"
                  (ngModelChange)="onScheduleGroupChange()">
            <option [ngValue]="null" disabled>
              {{ groupsLoading ? 'Loading groups…' : 'Choose Group' }}
            </option>
            <option *ngFor="let g of assignGroups" [ngValue]="g">{{ g.name }}</option>
          </select>
          <wf-icon name="chevron-down" [size]="18"></wf-icon>
        </div>
      </div>

      <div class="sf-sched" *ngIf="activeGroup && activeSchedule as s">
        <div class="sf-row">
          <label class="sf-label">Enable schedule</label>
          <app-custom-switch [enabled]="s.enabled" (onToggle)="s.enabled = $event"></app-custom-switch>
        </div>

        <ng-container *ngIf="s.enabled">
          <h3 class="sf-heading">Date &amp; Time</h3>
          <div class="sf-grid">
            <div>
              <label class="sf-label">Start Date <span class="sf-req">*</span></label>
              <app-custom-date [dateFormatted]="formatScheduleDate(s.startDate)"
                               placeholder="Select Date" (onSelectDate)="setScheduleStartDate($event)"></app-custom-date>
              <span class="sf-err" *ngIf="scheduleErrors.startDate">{{ scheduleErrors.startDate }}</span>
            </div>
            <div>
              <label class="sf-label">Start Time</label>
              <input class="sf-input" placeholder="--:-- --" readonly
                     [owlDateTimeTrigger]="wfStartTime" [owlDateTime]="wfStartTime" [(ngModel)]="s.startTime" />
              <owl-date-time [pickerType]="'timer'" [hour12Timer]="true" #wfStartTime></owl-date-time>
            </div>
            <div>
              <label class="sf-label">End Date</label>
              <app-custom-date [dateFormatted]="formatScheduleDate(s.endDate)"
                               placeholder="Select Date" (onSelectDate)="setScheduleEndDate($event)"></app-custom-date>
              <span class="sf-err" *ngIf="scheduleErrors.endDate">{{ scheduleErrors.endDate }}</span>
            </div>
            <div>
              <label class="sf-label">End Time</label>
              <input class="sf-input" placeholder="--:-- --" readonly
                     [owlDateTimeTrigger]="wfEndTime" [owlDateTime]="wfEndTime" [(ngModel)]="s.endTime" />
              <owl-date-time [pickerType]="'timer'" [hour12Timer]="true" #wfEndTime></owl-date-time>
            </div>
          </div>

          <h3 class="sf-heading">Recurrence</h3>
          <label class="sf-label">Repeat Every <span class="sf-req">*</span></label>
          <div class="sf-freq">
            <div>
              <input type="text" class="sf-input sf-num" maxlength="2" placeholder="00"
                     [(ngModel)]="s.interval" onkeypress="return (/\d/g.test(event.key))" />
            </div>
            <div>
              <app-dropdown [form]="true" [options]="frequencyUnitOptions" [fields]="['id','unit']"
                            label="{{ s.unit || 'Select Frequency' }}"
                            (onSelectOption)="setScheduleFrequencyUnit($event)"></app-dropdown>
            </div>
          </div>
          <span class="sf-err" *ngIf="scheduleErrors.interval">{{ scheduleErrors.interval }}</span>

          <div *ngIf="s.unit === 'Week(s)'" class="sf-weekly">
            <label class="sf-label">Repeat On <span class="sf-req">*</span></label>
            <div class="sf-days">
              <button type="button" *ngFor="let d of daysOfWeek" class="sf-day"
                      [class.on]="s.days.includes(d)" (click)="toggleActiveScheduleDay(d)">
                {{ d.toUpperCase().substring(0, 3) }}
              </button>
            </div>
            <span class="sf-err" *ngIf="scheduleErrors.days">{{ scheduleErrors.days }}</span>
          </div>

          <div *ngIf="s.unit === 'Month(s)'" class="sf-monthly">
            <label class="sf-radio">
              <input type="radio" [value]="'specific'" [(ngModel)]="s.monthMode" /> On day
              <app-dropdown [form]="true" [options]="specificDayOptions" [fields]="['id','unit']"
                            [disabled]="s.monthMode !== 'specific'"
                            label="{{ s.specificDay || 'Select' }}"
                            (onSelectOption)="setScheduleSpecificDay($event)"></app-dropdown>
            </label>
            <label class="sf-radio">
              <input type="radio" [value]="'firstlast'" [(ngModel)]="s.monthMode" /> On the
              <app-dropdown [form]="true" [options]="firstOrLastOptions" [fields]="['id','day']"
                            [disabled]="s.monthMode !== 'firstlast'"
                            label="{{ s.firstOrLast || 'Select' }}"
                            (onSelectOption)="setScheduleFirstOrLast($event)"></app-dropdown>
              day
            </label>
          </div>

          <h3 class="sf-heading">Overdue</h3>
          <label class="sf-label">Mark overdue after</label>
          <div class="sf-freq">
            <div>
              <input type="text" class="sf-input sf-num" maxlength="3" placeholder="00"
                     [(ngModel)]="s.overdueInterval" onkeypress="return (/\d/g.test(event.key))" />
            </div>
            <div>
              <app-dropdown [form]="true" [options]="overdueUnitOptions" [fields]="['id','unit']"
                            label="{{ s.overdueUnit || 'Select' }}"
                            (onSelectOption)="setScheduleOverdueUnit($event)"></app-dropdown>
            </div>
          </div>

          <div class="sf-summary" *ngIf="renderScheduleSummary()">{{ renderScheduleSummary() }}</div>
        </ng-container>
      </div>
    </div>

    <div class="aw-foot">
      <button class="aw-cancel" type="button" (click)="closeSchedule()">Cancel</button>
      <button class="aw-assign" type="button" [disabled]="assignSaving || !canSaveSchedule" (click)="saveSchedule()">
        {{ assignSaving ? 'Saving…' : 'Save schedule' }}
      </button>
    </div>
  </div>
</div>

<!-- ===================== CONFIRM MODAL ===================== -->
<div class="confirm-modal" *ngIf="confirm.open">
  <div class="confirm-modal-card" role="dialog" aria-modal="true" aria-labelledby="workflow-confirm-title">
    <div class="cm-top">
      <div class="cm-icon"><wf-icon name="alert-triangle" [size]="20"></wf-icon></div>
      <div class="cm-body">
        <h3 class="cm-title" id="workflow-confirm-title">{{ confirm.title }}</h3>
        <p class="cm-text">{{ confirm.body }}</p>
        <ul class="cm-detail-list" *ngIf="confirm.details.length">
          <li *ngFor="let detail of confirm.details">{{ detail }}</li>
        </ul>
        <div class="cm-extra" *ngIf="confirm.kind === 'deactivate'">
          <div class="cm-warn" *ngIf="confirm.inFlight > 0">
            <wf-icon name="alert-triangle" [size]="14"></wf-icon>
            <span>{{ confirm.inFlight }} items are currently in flight. They will continue to run on this workflow.</span>
          </div>
          <label class="sub mt">Reason (optional)</label>
          <input type="text" [(ngModel)]="deactivateReason" placeholder="e.g. Superseded by v2" />
        </div>
      </div>
    </div>
    <div class="cm-actions">
      <button type="button" class="top-btn" data-confirm-cancel (click)="confirmCancel()">Cancel</button>
      <button type="button" class="top-btn" [ngClass]="confirm.okClass" [disabled]="revertingCardId !== null" (click)="confirmOk()">{{ confirm.okLabel }}</button>
    </div>
  </div>
</div>

<!-- ===================== ACTION COMMENT MODAL ===================== -->
<div *ngIf="actionCommentModalOpen" class="confirm-modal">
  <div class="confirm-modal-card action-comment-card">
    <h3 class="cm-title">{{ actionCommentTarget?.requireComment ? 'Edit' : 'Add' }} comment for {{ actionCommentTarget?.label }}</h3>
    <p class="cm-text">Add the comment prompt or instruction shown when this action is used.</p>
    <textarea [(ngModel)]="actionCommentText" rows="6" maxlength="1024" class="action-comment-input"></textarea>

    <div class="cm-actions">
      <button class="top-btn" (click)="closeActionComment()" type="button">Cancel</button>
      <button *ngIf="actionCommentTarget?.requireComment" class="top-btn danger"
              (click)="clearActionComment()" type="button">
        Remove
      </button>
      <button (click)="saveActionComment()" [disabled]="!isActionCommentSubmitEnabled()"
              type="button" class="top-btn success">
        Done
      </button>
    </div>
  </div>
</div>

<!-- ===================== TOAST ===================== -->
<div class="toast" [class.show]="toastShow">
  <wf-icon *ngIf="toastIcon" [name]="toastIcon" [size]="16"></wf-icon>
  <span>{{ toastMsg }}</span>
  <button *ngIf="toastAction" class="toast-action" (click)="runToastAction()">{{ toastAction.label }}</button>
</div>

<!-- ===================== ROLE REGISTRY MODAL ===================== -->
<app-role-registry [open]="roleModalOpen" [workflowTemplateId]="workflowTemplateId" (closed)="closeRoleModal()"></app-role-registry>
